<template>
    <div
        :class="`row no-gutters col-12 border-bottom py-3 align-items-center ${ viewMode !== 'primary' ? 'default-base-color' : 'px-0' }`">
        <selected-product :product="item" :discountAmount="productDiscount" :stockDeductionType="stockDeductionType" @dropdown-toggle="handleDropdownToggle"
                          :dropdown-state="item.dropdownActive"/>
        <count-control :item-upc="item.upc" :quantity="item.quantity" @quantity-change="handleQuantityChangeEvent"/>
        <h6 class="col-3 mb-0 item-subtotal">{{ numberWithCurrencySymbol(individualItemTotalPrice) }}</h6>
        <div class="col-1 item-remove-btn text-right" @click="handleCartItemClose">
            <app-icon name="x-circle" class="text-danger size-18"/>
        </div>
        <small class="text-danger py-2" v-if="stockAmountExceeded">{{$t('specified_quantity_unavailable_in_stock')}}</small>
        <div v-if="item.dropdownActive" class="product-details-dropdown col-12 row no-gutters pt-3">
            <div class="row col-12 no-gutters justify-content-between pb-2">
                <app-input
                    type="number"
                    class="col-6 pr-3"
                    :placeholder="$placeholder('price')"
                    @focusout="handleCartItemPriceChange"
                    v-model="productPrice"
                    :min-number="0"
                />
                <div class="col-6 row no-gutters">
                    <app-input
                        type="number"
                        class="col-9 pr-2"
                        :disabled="getFlatDiscountActiveStatus"
                        :placeholder="$placeholder('discount')"
                        @keyup="handleCartItemDiscountChange"
                        :key="productDiscountType"
                        v-model="productDiscount"
                    />

                    <app-input
                        type="select"
                        class="col-3"
                        :list="discountTypes"
                        :disabled="getFlatDiscountActiveStatus"
                        v-model="productDiscountType"
                        list-value-field="type"
                    />
                </div>
            </div>
            <div class="row no-gutters col-12 py-2">
                <app-input
                    type="checkbox"
                    class="col-6 mb-3"
                    :list="stockDeductionTypeList"
                    v-model="stockDeductionType"
                    list-value-field="type"
                />
                <app-input
                    type="textarea"
                    class="d-block col-12"
                    :text-area-rows="5"
                    :placeholder="$placeholder('note')"
                    v-model="productNote"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SelectedProduct from "./SelectedProduct";
import CountControl from "./CountControl";
import {mapMutations, mapGetters} from "vuex";
import {numberWithCurrencySymbol} from "../../../../Helper/Helper";

export default {
    name: 'cart-item',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    components: {
        'selected-product': SelectedProduct,
        'count-control': CountControl
    },
    data() {
        // let price1 = (!isNaN(this.item.price))?this.item.price:'';
        let price1 = (!isNaN(this.item.selling_price))?this.item.selling_price:'';
        let price2 = (!isNaN(this.item.variant?.selling_price))?this.item.variant?.selling_price:'';
        return {
            stockAmountExceeded: false,
            discountTypes: [
                {id: 'percentage', type: '%'},
                {id: 'fixed', type: '$'}
            ],
            stockDeductionTypeList: [
                {id: "2", type: 'CFU'}
            ],
            productPrice: +price1 || +price2,
            productDiscount: +this.item.discount_value || '',
            productDiscountType: this.item.discount_type || 'percentage',
            productDetailsDropdownActive: false,
            productNote: this.item.note ? this.item.note : '',
            stockDeductionType: this.item.main_category != '2' ? '2' : '1',
        }
    },
    computed: {
        ...mapGetters(['cartItems', 'viewMode', 'getOrderResumeState', 'getFlatDiscountActiveStatus','getMainDiscountData']),
        discountAmount() {
            return this.productDiscountType === 'percentage' ? +(this.productPrice * +(+this.productDiscount / 100)).toFixed(2) : +this.productDiscount;
        },
        individualItemTotalPrice() {
            // const unitTaxAmount = (this.item.tax_amount / 100) * (+this.item.price - +this.discountAmount.toFixed(2));
            // const discountAmountDeducted = +(+this.item.quantity * (+this.item.price - +this.discountAmount.toFixed(2)));
            // return (discountAmountDeducted + (unitTaxAmount * +this.item.quantity)).toFixed(2);

            // const unitTaxAmount = (this.item.tax_amount / 100) * (+this.item.price);
            const unitTaxAmount = 0;
            // console.log("item sub total",(this.item.price * this.item.quantity) - (((this.item.price * this.item.quantity) * this.item.discount_value)/100));

            if(this.item.discount_type == 'percentage') {
                return ((this.item.price * this.item.quantity) - (((this.item.price * this.item.quantity) * this.item.discount_value)/100)).toFixed(2);
            } else {
                return ((this.item.price * this.item.quantity) - this.item.discount_value).toFixed(2);
            }


            // const discountAmountDeducted = +(+this.item.quantity * (+this.item.price));
            // return ((discountAmountDeducted + (unitTaxAmount * +this.item.quantity)).toFixed(2)) - this.discountAmount.toFixed(2);

        }
    },
    watch: {
        getMainDiscountData(data){
            if(data.from != 'item') {
                this.productDiscount = data.discountVal;
                this.productDiscountType = data.discountType;
            }
        },
        individualItemTotalPrice: {
            immediate: true,
            handler: function (newPrice) {
                this.calculatePrices(newPrice);
            }
        },
        'cartItems.length'() {
            this.setSubTotalOnState();
        },
        productDiscountType() {
            this.productDiscount = '';
        },
        productDiscount() {
            this.SET_ITEM_DISCOUNT_DETAILS({
                upc: this.item.upc,
                discount_type: this.productDiscountType,
                discount_value: this.productDiscount,
                discount_amount: this.discountAmount
            });
            if(this.getMainDiscountData.from == 'item') {
                this.setMainDiscountData({'discountVal':'','from':'item','discountType':this.productDiscountType});
            }
            
        },
        productNote(newNote) {
            this.SET_ITEM_NOTE({upc: this.item.upc.toString(), note: newNote});
        },
        stockDeductionType() {
            this.CHANGE_CART_ITEM_STOCK_BRANCH({upc: this.item.upc, stock_deduction_type: this.stockDeductionType});
        },
        productPrice: {
            immediate: true,
            handler: function (newPrice) {
                this.CHANGE_CART_ITEM_PRICE({upc: this.item.upc.toString(), newPrice});
                this.SET_ITEM_DISCOUNT_DETAILS({
                    upc: this.item.upc,
                    discount_type: this.productDiscountType,
                    discount_value: this.productDiscount,
                    discount_amount: this.discountAmount
                });
            }
        }
    },
    methods: {
        handleQuantityChangeEvent(newQuantity) {
            const stockAmountExceeded = newQuantity > this.item.stock.available_qty;
            if (stockAmountExceeded) this.$toastr.e(this.$t('stock_out_message', {product_name: this.item.name, available_qty: this.item.stock.available_qty}));
        },
        numberWithCurrencySymbol(value) {
            return numberWithCurrencySymbol(value);
        },
        calculatePrices(newPrice) {
            this.CHANGE_CART_ITEM_SELLING_PRICE({upc: this.item.upc , new_product_price: newPrice});
            this.setSubTotalOnState();
        },
        setSubTotalOnState() {
            const subTotal = this.cartItems.map(item => +item.sub_total).reduce((a, v) => a + v, 0);
            this.SET_SUBTOTAL(subTotal);
        },
        ...mapMutations(['REMOVE_ITEM_FROM_CART', 'CHANGE_CART_ITEM_SELLING_PRICE', 'CHANGE_CART_ITEM_PRICE', 'SET_ITEM_DISCOUNT_DETAILS', 'SET_ITEM_NOTE', 'TOGGLE_CART_ITEM_DROPDOWN', 'SET_SUBTOTAL', 'CHANGE_CART_ITEM_STOCK_BRANCH', 'setMainDiscountData']),
        handleCartItemClose() {
            this.REMOVE_ITEM_FROM_CART(this.item.upc);
        },
        handleDropdownToggle() {
            this.TOGGLE_CART_ITEM_DROPDOWN({cartItemUpc: +this.item.upc, show: !this.item.dropdownActive})
        },
        handleCartItemDiscountChange() {
            if (+`${this.productDiscount}`[0] === 0) this.productDiscount = +`${this.productDiscount}`.slice(1);

            if (this.productDiscountType === 'percentage') {
                if (this.productDiscount >= 100) this.productDiscount = 100;
                if (this.productDiscount !== '' && this.productDiscount <= 1) this.productDiscount = 1;
            } else {
                if (this.productDiscount >= this.productPrice) this.productDiscount = this.productPrice;
                if (this.productDiscount <= 0) this.productDiscount = '';
            }
            if(this.getMainDiscountData.from == 'order') {
                this.setMainDiscountData({'discountVal':'','from':'item','discountType':this.productDiscountType});
            }
        },
        handleCartItemPriceChange() {
            if (this.productPrice <= 0) this.productPrice = 0;
        }
    }
}
</script>

<style lang="sass">
.item-remove-btn
    transition: 150ms
    cursor: pointer

.item-subtotal
    font-size: 12px
</style>
